import { configureFetchWithAuth } from '@kurotetsu/share/apis/fetchWithAuth';

configureFetchWithAuth({
  apiEnv: import.meta.env.VITE_APP_ENV ?? '',
  apiHost: import.meta.env.VITE_API_TTRS_HOST ?? '',
  getToken: () => null,
  setToken: () => undefined,
  noAuthPaths: ['/api/v1/bookings']
});
